import { render, staticRenderFns } from "./main-side-bar.vue?vue&type=template&id=ac129758&scoped=true&"
import script from "./main-side-bar.vue?vue&type=script&lang=js&"
export * from "./main-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./main-side-bar.vue?vue&type=style&index=0&id=ac129758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac129758",
  null
  
)

export default component.exports